<template>
    <div class="mb-24 sm:mb-28 mx-3 sm:mx-4 p-4 bg-skin-b-list-back border-x border-b border-skin-b-list-bord shadow rounded-b-lg">
        <form @submit.prevent="submitForm" @keydown.enter.prevent>
            <div class="grid gap-4 sm:grid-cols-2">
                <slot name="formgrid"></slot>
            </div>
            <slot name="formbottom"></slot>
        </form>
    </div>
</template>
<script>
</script>
<style scoped>
</style>